import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
const Hero = () => {
  return <div className="relative bg-gray-900 text-white" data-id="element-196">
      <div className="absolute inset-0 overflow-hidden" data-id="element-197">
        <img src="https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Automatic driving lessons in Northampton with DVSA-approved instructors - modern car interior" className="w-full h-full object-cover opacity-30" data-id="element-198" />
      </div>
      <div className="container mx-auto px-4 py-16 md:py-24 relative z-10" data-id="element-199">
        <div className="max-w-3xl" data-id="element-200">
          <h1 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-201">
            Pass Faster. Drive Smarter.
          </h1>
          <p className="text-xl md:text-2xl mb-8" data-id="element-202">
            Automatic driving lessons in Northampton with patient instructors,
            flexible times, and high pass rates.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 flex-wrap" data-id="element-203">
            <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-amber-500 hover:bg-amber-600 text-white px-6 py-3 rounded-md font-medium text-center transition-colors" aria-label="Book your driving lessons now" data-id="element-204">
              Book Now
            </a>
            <Link to="/standard-lessons" className="bg-white hover:bg-gray-100 text-gray-800 px-6 py-3 rounded-md font-medium text-center transition-colors" aria-label="View our automatic driving lessons packages" data-id="element-205">
              View Packages
            </Link>
            <a href="tel:07481300600" className="flex items-center justify-center gap-2 bg-gray-800 hover:bg-gray-700 text-white px-6 py-3 rounded-md font-medium transition-colors" aria-label="Call us to book driving lessons" data-id="element-206">
              <Phone size={18} aria-hidden="true" data-id="element-207" />
              Call Us: 07481 300 600
            </a>
          </div>
        </div>
      </div>
    </div>;
};
export default Hero;